"use strict";
/*!
 *
 *  shop.ts
 *
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ShopMap = exports.ShopSearch = void 0;
var vue_1 = __importDefault(require("vue"));
var axios_1 = __importDefault(require("axios"));
var ShopSearch = /** @class */ (function () {
    function ShopSearch() {
        this.id = 'ShopSearch';
        if (document.getElementById(this.id)) {
            this.build();
        }
        ;
    }
    ShopSearch.prototype.build = function () {
        var self = this;
        new vue_1.default({
            el: '#' + this.id,
            data: {
                inited: false,
                area: '',
                pref: '',
                lat: '',
                lng: '',
                free: '',
                target: 'wd',
                areaList: [],
                prefList: [],
                hideAreaError: 'true',
                hideLocationError: 'true',
                hideKeywordError: 'true'
            },
            computed: {
                areaErrorText: function () {
                    var pre = (this.area == '' ? '「地区」' : '') + (this.pref == '' ? '「都道府県」' : '');
                    if (pre == '') {
                        this.hideAreaError = 'true';
                    }
                    ;
                    return "\u203B" + pre + "\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044";
                },
                keywordErrorText: function () {
                    if (this.free == '') {
                        this.hideKeywordError = 'true';
                    }
                    ;
                    return "\u203B\u30AD\u30FC\u30EF\u30FC\u30C9\u3092\u5165\u529B\u3057\u3066\u304F\u3060\u3055\u3044";
                }
            },
            watch: {
                'area': function () {
                    return __awaiter(this, void 0, void 0, function () {
                        var res, error_1;
                        return __generator(this, function (_a) {
                            switch (_a.label) {
                                case 0:
                                    if (!(this.area !== '')) return [3 /*break*/, 5];
                                    _a.label = 1;
                                case 1:
                                    _a.trys.push([1, 3, , 4]);
                                    return [4 /*yield*/, axios_1.default.get("/api/pref.php?area_id=" + this.area)];
                                case 2:
                                    res = _a.sent();
                                    this.prefList = res.data;
                                    return [3 /*break*/, 4];
                                case 3:
                                    error_1 = _a.sent();
                                    this.prefList = [];
                                    return [3 /*break*/, 4];
                                case 4:
                                    ;
                                    return [3 /*break*/, 6];
                                case 5:
                                    this.areaList = [];
                                    _a.label = 6;
                                case 6:
                                    ;
                                    return [2 /*return*/];
                            }
                        });
                    });
                },
                'free': function () {
                    if (this.free !== '') {
                        this.hideKeywordError = 'true';
                    }
                    ;
                }
            },
            mounted: function () {
                return __awaiter(this, void 0, void 0, function () {
                    var res, error_2;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                _a.trys.push([0, 2, , 3]);
                                return [4 /*yield*/, axios_1.default.get('/api/area.php')];
                            case 1:
                                res = _a.sent();
                                this.areaList = res.data;
                                return [3 /*break*/, 3];
                            case 2:
                                error_2 = _a.sent();
                                this.areaList = [];
                                return [3 /*break*/, 3];
                            case 3:
                                ;
                                this.inited = true;
                                return [2 /*return*/];
                        }
                    });
                });
            },
            methods: {
                submitArea: function (e) {
                    if (this.area == '' || this.pref == '') {
                        e.preventDefault();
                        this.hideAreaError = 'false';
                    }
                },
                setLocation: function (e) {
                    var _this = this;
                    e.preventDefault();
                    self.getLocation(function (pos) {
                        var crd = pos.coords;
                        _this.lat = crd.latitude.toString();
                        _this.lng = crd.longitude.toString();
                        _this.hideLocationError = 'true';
                        var form = e.target.closest('form');
                        setTimeout(function () {
                            form.submit();
                        }, 1);
                    }, function () {
                        _this.hideLocationError = 'false';
                    });
                },
                submitKeyword: function (e) {
                    if (this.free == '') {
                        e.preventDefault();
                        this.hideKeywordError = 'false';
                    }
                }
            }
        });
    };
    ShopSearch.prototype.getLocation = function (success, error) {
        if (navigator.geolocation) {
            var geo = navigator.geolocation;
            if (geo) {
                geo.getCurrentPosition(success, error, {
                    enableHighAccuracy: false,
                    timeout: 5000,
                    maximumAge: 0
                });
            }
            else {
                error;
            }
        }
    };
    return ShopSearch;
}());
exports.ShopSearch = ShopSearch;
var ShopMap = /** @class */ (function () {
    function ShopMap() {
        this.elem = document.getElementById('ShopMap');
        // apiKey: string = 'AIzaSyCK4JBhN5XNI7EGqV7iYPBt3MuMnZzRcQc';
        this.shop = [];
        this.center = {
            lat: 0,
            lng: 0
        };
        this.markers = [];
        this.infowindows = [];
        if (this.elem) {
            this.shop = this.getShop(JSON.parse(this.elem.dataset.shop));
            this.center = this.elem.dataset.center ? this.getCenter(JSON.parse(this.elem.dataset.center)) : {
                lat: this.shop[0].lat,
                lng: this.shop[0].lng
            };
            this.createMap();
        }
        ;
    }
    ShopMap.prototype.createMap = function () {
        var _this = this;
        this.map = new google.maps.Map(document.getElementById('ShopMapMain'), {
            center: {
                lat: this.center.lat,
                lng: this.center.lng
            },
            zoom: 10
        });
        this.shop.forEach(function (item, i) {
            _this.markers[i] = new google.maps.Marker({
                position: {
                    lat: item.lat,
                    lng: item.lng
                },
                icon: '/assets/img/common/pin.png',
                map: _this.map,
                title: item.shop_name
            });
            _this.infowindows[i] = new google.maps.InfoWindow({
                content: "\n\t\t\t\t\t<div class=\"shp-Infowindow\">\n\t\t\t\t\t\t<div class=\"shp-Infowindow_Name\">" + item.shop_name + "</div>\n\t\t\t\t\t\t<div class=\"shp-Infowindow_Address\">\u3012" + item.zip + "\u3000" + item.address + "</div>\n\t\t\t\t\t\t<div class=\"shp-Infowindow_Tel\">" + (item.phone !== '' ? 'TEL：' + item.phone : '') + "</div>\n\t\t\t\t\t</div>\n\t\t\t\t"
            });
            _this.markers[i].addListener('click', function () {
                _this.infowindows.forEach(function (iw) {
                    iw.close();
                });
                _this.infowindows[i].open({
                    anchor: _this.markers[i],
                    map: _this.map,
                    shouldFocus: false
                });
            });
        });
        google.maps.event.addListenerOnce(this.map, 'tilesloaded', function () {
            $(_this.elem).find('.sw-Loading').hide(300);
        });
    };
    ShopMap.prototype.getShop = function (shop) {
        return shop.map(function (val) {
            return {
                shop_name: val.shop_name,
                zip: val.zip,
                address: val.address,
                phone: val.phone,
                lat: Number(val.latitude),
                lng: Number(val.longitude)
            };
        });
    };
    ShopMap.prototype.getCenter = function (center) {
        return {
            lat: Number(center.latitude),
            lng: Number(center.longitude)
        };
    };
    return ShopMap;
}());
exports.ShopMap = ShopMap;
